export default __webpack_public_path__ + "6b6aaf4921868fcef8a0888c075fe9bf.png";